import { useState, useEffect } from 'react';
import { api } from '../api/client';

export interface ChartsData {
  byPersonProject: Array<{ initials: string; projectName: string; hours: number }>;
  byWeekProject:   Array<{ weekStart: string; projectName: string; hours: number }>;
  byPersonWeek:    Array<{ initials: string; weekStart: string;   hours: number }>;
}

export function useCharts(from: string, to: string) {
  const [data,    setData]    = useState<ChartsData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState<string | null>(null);

  useEffect(() => {
    if (!from || !to) return;
    setLoading(true);
    setError(null);
    api.get<ChartsData>(`/reports/charts?from=${from}&to=${to}`)
      .then(setData)
      .catch((e: any) => setError(e.message))
      .finally(() => setLoading(false));
  }, [from, to]);

  return { data, loading, error };
}
